<script>
import CommonHome from '@/views/Information/CommonHome'
import api from '@/utils/api/operation'
export default {
  name: 'NoticeHome',
  extends: CommonHome,
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    navTitle() {
      return '通知公告'
    }
  },
  methods: {
    loadData(data) {
      let params = {
        page: data.page,
        rows: data.rows,
        BT: this.searchValue
      }
      return api.getNoticeList(params).then(res => {
        this.list = res.data.rowsList
        return Promise.resolve(res)
      })
    },
    itemClicked(item) {
      this.$router.push({
        name: 'NoticeDetail',
        query: {
          rid: item.RID
        }
      })
    }
  }
}
</script>
